import { type VPAuthConfig } from '@vp/ubik-context';
import { getEnvironmentSuffix } from '../common/hooks/useAccountResources';

export const createAuthConfig = (culture: string): VPAuthConfig => ({
  culture,
  developmentMode: getEnvironmentSuffix() === 'dev',
  options: {
    requireSession: true,
    customText: 'Sign in to see your account',
    clientID: process.env.COAM_CLIENT_ID || process.env.AUTH_CLIENT_ID,
  },
});
